import LoginCard from "../../components/LoginCard";

export default function Login() {
  return (
    <div>
      <LoginCard cardWidthLG="30%" cardWidthXS="80%"></LoginCard>
    </div>
  );
}
